import { ReactNode } from 'react';
import { Platform } from 'react-native';
import {
  BodyText,
  TBodyTextProps,
} from '@/common/components/BodyText/BodyText';
import { cn } from '@/common/theme/tv.config';

export type TDOMProps = {
  className?: string;
  children?: ReactNode;
} & TBodyTextProps;

export function Ul({ className, children, ...textProps }: TDOMProps) {
  return (
    <BodyText
      as={Platform.OS === 'web' ? 'ul' : undefined}
      {...textProps}
      className={cn('pl-sm', className)}
    >
      {children}
    </BodyText>
  );
}

export function Li({ className, children, ...textProps }: TDOMProps) {
  return (
    <BodyText
      as={Platform.OS === 'web' ? 'li' : undefined}
      {...textProps}
      className={cn('ml-sm list-disc', className)}
    >
      {children}
    </BodyText>
  );
}
